module.exports = __webpack_public_path__ + "static/media/platformFeatures4.33413e84.png";